import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"
import { convertFolderName } from "routes/schedule/folder-manager/folder-management"
import { api } from "lib/graphql/api"

export const modelStats = api((group) =>
    query(
        gql`
            query modelStats($group: String) {
                getModelStats(group: $group) {
                    id
                    stats {
                        name
                        schedules {
                            id
                            count
                            units
                            annualMinutes
                            total {
                                classification
                                count
                                minutes
                                annualMinutes
                            }
                            skills {
                                skill
                            }
                            periods {
                                interval
                                period
                                frequency
                                count
                                minutes
                                annualMinutes
                                measurements {
                                    classification
                                }
                            }
                        }
                        children {
                            id
                            count
                            annualMinutes
                            allSkills {
                                skill
                            }
                            allPeriods {
                                interval
                                period
                                frequency
                                count
                                minutes
                                annualMinutes
                                measurements {
                                    classification
                                    count
                                    minutes
                                    annualMinutes
                                }
                            }
                            total {
                                classification
                                count
                                minutes
                                annualMinutes
                            }
                            totalCount
                            totalAnnualMinutes
                        }
                    }
                    annualMinutes
                    count
                    profile {
                        annualMinutes
                        count
                        total {
                            classification
                            count
                            annualMinutes
                        }
                        id
                        name
                    }
                    periods {
                        count
                        annualMinutes
                        minutes
                        period
                        interval
                        frequency
                    }
                    skills {
                        skill
                        count
                        annualMinutes
                    }
                    total {
                        classification
                        count
                        annualMinutes
                    }
                }
            }
        `,
        { group: convertFolderName(group) },
        { returns: "getModelStats" }
    )
)
